// removed by extract-text-webpack-plugin
module.exports = {"strongest":"theme__strongest___1JWaI","header":"theme__header___1Hwwr","container":"theme__container___KAA6f","table":"theme__table___2XYf6","fadeUp":"theme__fadeUp___2REqw","lateFadeUp":"theme__lateFadeUp___EySi2","lateFadeIn":"theme__lateFadeIn___2KJyv"};


//////////////////
// WEBPACK FOOTER
// ./client/modules/debate/components/Strongest/theme.scss
// module id = 483
// module chunks = 0